export default "__VITE_ASSET__B32s0jNu__"